import { defineMessages } from 'react-intl';

const PRESS_PAGE_STRINGS = defineMessages({
  HERO_SUBHEADER_TEXT: {
    defaultMessage: 'The most trusted outdoor platform in the world'
  },
  HERO_HEADER_TEXT: {
    defaultMessage: 'AllTrails in the news'
  },
  HERO_ALT: {
    defaultMessage: 'Two people hiking near a waterfall while holding hands'
  }
});

enum PressNavId {
  About = 'press-page-about',
  Highlights = 'press-page-highlights',
  PressRoom = 'press-page-press-room',
  Kit = 'press-page-kit',
  Leadership = 'press-page-leadership'
}

export { PRESS_PAGE_STRINGS, PressNavId };
